export const formatDate = (
  timestamp: number,
  format: string | null
): string => {
  let f = format;
  if (!f) {
    f = "en-US";
  }
  return new Intl.DateTimeFormat(f, {
    year: "numeric",
    month: "short",
    day: "2-digit",
  }).format(new Date(timestamp * 1000));
};

export const formatDateWithTime = (
  timestamp: number,
  format: string | null
): string => {
  let f = format;
  if (!f) {
    f = "en-US";
  }

  return new Intl.DateTimeFormat(f, {
    year: "numeric",
    month: "short",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
  }).format(new Date(timestamp * 1000));
};

export const getRelativeTime = (
  date: Date,
  locale: string,
  isPast = false
): string => {
  const now = new Date();
  const elapsed = Math.abs(date.getTime() - now.getTime()) / 1000;

  const rtf = new Intl.RelativeTimeFormat(locale, {
    numeric: "always",
    style: "long",
  });
  type TimeUnit = { unit: Intl.RelativeTimeFormatUnit; seconds: number };

  const units: TimeUnit[] = [
    { unit: "year", seconds: 31536000 },
    { unit: "month", seconds: 2592000 },
    { unit: "week", seconds: 604800 },
    { unit: "day", seconds: 86400 },
    { unit: "hour", seconds: 3600 },
    { unit: "minute", seconds: 60 },
    { unit: "second", seconds: 1 },
  ];

  for (const { unit, seconds } of units) {
    if (elapsed >= seconds || unit === "second") {
      let value = Math.round(elapsed / seconds);

      if (isPast) {
        value = value * -1;
      }

      return rtf.format(value, unit);
    }
  }

  return "Unknown";
};
